import { useState } from "react";
import { RotateCcw, Upload } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useExampleVideo } from "@/components/apply/VideoPicker";
import { uploadChunks } from "@/lib/upload";

export const ExampleVideoPanel = () => {
  const { src, custom, refresh } = useExampleVideo();
  const [progress, setProgress] = useState(null);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("video/") || file.size > 80 * 1024 * 1024) return toast.error("Scegli un video di massimo 80 MB");
    try {
      await uploadChunks("/admin/example-video", file, setProgress);
      toast.success("Video di esempio aggiornato");
      refresh();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setProgress(null);
    }
  };
  const reset = async () => {
    if (!window.confirm("Tornare al video provvisorio?")) return;
    await api.delete("/admin/example-video");
    refresh();
  };

  return (
    <div data-testid="example-video-panel" className="flex flex-col gap-8 md:flex-row">
      <video key={src} src={src} controls muted playsInline data-testid="example-video-admin-player" className="aspect-[9/16] w-full max-w-[260px] bg-[#1c1418] object-cover" />
      <div className="max-w-md space-y-4">
        <p className="font-display text-3xl uppercase leading-none">Video di esempio</p>
        <p className="text-sm">Appare nel form di candidatura accanto al caricamento del video. Ora stai usando: <b data-testid="example-video-source">{custom ? "il vostro video" : "il video provvisorio"}</b>.</p>
        <p className="text-xs text-[#1c1418]/70">Consigliato: video verticale, massimo 1 minuto, 80 MB.</p>
        <label data-testid="example-video-upload" className="flex cursor-pointer items-center justify-center gap-2 bg-[#1c1418] px-5 py-3 font-mono text-xs uppercase tracking-[0.2em] text-white">
          <Upload className="h-4 w-4 text-[#e9458f]" /> {progress !== null ? `Caricamento ${progress}%` : "Carica il vostro video"}
          <input type="file" accept="video/*" onChange={upload} disabled={progress !== null} className="hidden" data-testid="example-video-input" />
        </label>
        {custom && (
          <button onClick={reset} data-testid="example-video-reset" className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] underline">
            <RotateCcw className="h-4 w-4" /> Torna al provvisorio
          </button>
        )}
      </div>
    </div>
  );
};
